import React, { useEffect } from "react"
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";


const SelectOptions = ({ Service, label, setOptions, placeholder, options, handleSelectChange, selectedOption, ...otherProps }) => {
    const service = new Service()
    const AuthData = useSelector(state => state.Auth)

    useEffect(() => {
        service.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name[`${AuthData.lang}`] ? item.name[`${AuthData.lang}`] :item.name.en,
                    value: item.id
                }
            })
            setOptions(newOptions)
        })
    }, [AuthData.lang])

    return (
        <>
            <label>{label}</label>
            <Select
                placeholder={placeholder}
                options={options}
                className='mb-3'
                onChange={(data) => {
                    handleSelectChange(data)
                }}
                value={selectedOption}
                {...otherProps}
            />
        </>
    )
}

export default SelectOptions